import {select, retry, put, take, takeEvery} from 'redux-saga/effects';
import {modal, config, loadScript, isEmpty} from 'helpers';
import {storedGoogleEvents} from 'store/activities/selectors';

export function* googleCalendarLoad() {
  yield take('APP_LAUNCH');
  yield retry(99, 5*60*1000, loadScript, 'https://apis.google.com/js/api.js');
  yield new Promise(resolve => window.gapi.load('client:auth2', resolve));
  yield window.gapi.client.init({
    ...config.googleCalendar,
    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
    scope: 'https://www.googleapis.com/auth/calendar',
  });
  yield put({
    type: 'GOOGLE_API_LOADED',
  });
  if (yield getUser()) {
    yield put({
      type: 'GOOGLE_CALENDAR_SIGNED_IN',
      user: yield getUser(),
    });
  }
}

export function* googleCalendarAuth() {
  yield takeEvery(['GOOGLE_CALENDAR_SIGN_IN', 'GOOGLE_CALENDAR_SIGN_OUT', 'SESSION_LOGOUT'], function* (action) {
    try {
      if (action.type == 'GOOGLE_CALENDAR_SIGN_IN') {
        yield window.gapi.auth2.getAuthInstance().signIn();
        const user = yield getUser();
        if (!user) {
          throw 'Please allow access to your Google Calendar';
        }
        yield put({
          type: 'GOOGLE_CALENDAR_SIGNED_IN',
          notification: 'Google Calendar: signed in!',
          user,
        });
      } else {
        if (yield getUser()) {
          yield window.gapi.auth2.getAuthInstance().signOut();
        }
        if (action.initiated == 'user') {
          yield put({
            type: 'GOOGLE_CALENDAR_SIGNED_OUT',
            notification: 'Google Calendar: signed out!',
          });
        }
        if (action.initiated == 'user' && !isEmpty(yield select(storedGoogleEvents))) {
          yield put({
            type: 'UI_DISPLAY_MODAL',
            id: 'DeleteImportedEventsPopup'
          });
        }
      }
    } catch (error) {
      yield put({
        type: 'UI_ERROR',
        error,
        errorMessage: typeof error == 'string' ? error : 'Failed to sign in with Google Calendar'
      });
    } finally {
      action.finally && action.finally();
    }
  });
}

function* getUser() {
  if (window.gapi && window.gapi.auth2) {
    const { isSignedIn, currentUser } = window.gapi.auth2.getAuthInstance() || {};
    if (isSignedIn && isSignedIn.get() && currentUser.get().hasGrantedScopes('https://www.googleapis.com/auth/calendar')) {
      return {
        email: currentUser.get().getBasicProfile().getEmail(),
      }
    }
  }
}
